import axios from "axios";
import store from "../../../../../stores/application/index.js.erb";
import _ from "lodash";

const scholarshipCompetitionPath = `/scholarship/student/competitions`;

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
};

const transformStatesResponse = (response) => {
    return {
        data: {
            competition: _.pick(response.data.competition,
                ['id', 'prtf_achievement_type_id', 'selectedId', 'department_id', 'updated_at']),
        }
    }
};

const showErrorMessage = () => {
    return store.dispatch("error_portfolio/addError", {
        type: "Error Server",
        message: "Ошибка сервера, попробуйте позже!",
        context: "Error Server",
        show: true
    });
};

const ScholarshipCompetitionApi = {

    async index() {
        get_token();
        try {
            return await axios.get(`${scholarshipCompetitionPath}`);
        } catch (e) {
            showErrorMessage();
            return null;
        }
    },

    async show(id) {
        get_token();
        try {
            return await axios.get(`${scholarshipCompetitionPath}/${id}`);
        } catch (e) {
            showErrorMessage();
            return null;
        }
    },

    async findExistingStatement(payload) {
        get_token();
        try {
            const response =
                await axios.get(`${scholarshipCompetitionPath}/find_existing_statement`);
            return transformStatesResponse(response);
        } catch (e) {
            showErrorMessage();
            return null;
        }
    },

    async create(payload) {
        get_token();
        try {
            const response =
                await axios.post(`${scholarshipCompetitionPath}`, {scholarship_competition: payload});
            return transformStatesResponse(response);
        } catch (e) {
            showErrorMessage();
            return null;
        }
    },

    async update(id, payload) {
        get_token();
        try {
            const response =
                await axios.patch(`${scholarshipCompetitionPath}/${id}`, {scholarship_competition: payload});
            return transformStatesResponse(response);
        } catch (e) {
            showErrorMessage();
            return null;
        }
    },

    async destroy(id) {
        get_token();
        try {
            await axios.delete(`${scholarshipCompetitionPath}/${id}`);
            return {
                data: {
                    competition: {
                        prtf_achievement_type_id: null,
                        selectedId: [],
                    }
                }
            };
        } catch (e) {
            showErrorMessage();
            return null;
        }
    },

    async settingStatementStudent() {
        get_token();
        try {
            return await axios.get(`${scholarshipCompetitionPath}/setting_statement_student`);
        } catch (e) {
            showErrorMessage();
            return null;
        }
    },

    async getAvailableAchievementsChoose() {
        get_token();
        try {
            return await axios.get(`${scholarshipCompetitionPath}/available_achievements_choose`);
        } catch (e) {
            showErrorMessage();
            return null;
        }
    },

}

export default ScholarshipCompetitionApi;